
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  CodeSurfer,
  CodeSurferColumns,
  Step,
} from "code-surfer";
import { github, vsDark } from "@code-surfer/themes";
import {
  Notes,
  Head,
  Appear,
  Split,
  Invert,
} from "mdx-deck";
import {
  Meta,
  Profile,
  Page,
  Colors,
  Heading,
  SubHeading,
  Paragraph,
  MarginBottom,
  Circle,
  Row,
  Center,
} from "./src";
import ReactNative from "./react-native.png";
import MyPic from "./images/my-pic.jpg";
import CureAppLogo from "./images/cureapp-logo.png";
import TwitterLogo from "./images/twitter-logo.png";
import GithubLogo from "./images/github-logo.png";
import VisRegDiff from "./images/vis-reg-diff.png";
import VisRegSide from "./images/vis-reg-diff-2.png";
import VisRegReport from "./images/vis-reg-report.png";
import RegSuitLogo from "./images/reg-suit-logo.jpg";
import StorybookLogo from "./images/storybook-logo.svg";
import CureAppTech from "./images/cureapp-tech.png";
import LightTheme from "./images/light-theme.png";
import DarkTheme from "./images/dark-theme.png";
import Branches from "./images/branches.svg";
import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  ActivityIndicator,
  StyleSheet,
  Image,
} from "react-native-web";
export const theme = { ...vsDark,
  fonts: {
    body: "-apple-system, system-ui, sans-serif"
  }
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Note = makeShortcode("Note");
const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Head mdxType="Head">
  <title>Visual Regression Test in React Native</title>
  <meta property="og:locale" content="ja_JP" />
  <meta property="og:title" content="Visual Regression Test in React Native" />
  <meta property="og:description" content="Introduction to React Native" />
  <meta property="og:type" content="article" />
  <meta property="og:url" content="https://lightning-talk-react-native-techstand.vercel.app/assets/oembed.json" />
  <meta property="og:image" content="https://lightning-talk-react-native-techstand.vercel.app/assets/card.png" />
  <meta property="article:published_time" content="2020-08-06T14:46:16.704Z" />
  <meta property="article:author" content="naturalclar" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="@Naturalclar" />
  <meta name="twitter:title" content="React Native の Visual Regression Test について" />
  <meta name="twitter:description" content="React Native の Visual Regression Test について" />
  <meta name="twitter:image" content="https://lightning-talk-react-native-techstand.vercel.app/assets/card.png" />
  <link rel="alternate" type="application/json+oembed" href={`https://lightning-talk-react-native-techstand.vercel.app/assets/oembed.json`} title="Visual Regression Test in React Native" />
    </Head>
    <Page mdxType="Page">
  <View style={{
        flex: 1,
        justifyContent: "flex-end"
      }} mdxType="View">
    <Heading mdxType="Heading">
      <Text style={{
            color: Colors.baseTextColor
          }} mdxType="Text">
        React Native{" "}
      </Text>
      <Text style={{
            color: "#d081c4"
          }} mdxType="Text">の</Text> <Text style={{
            color: Colors.secondaryColor
          }} mdxType="Text">
        Visual Regression Test{" "}
      </Text>
      <Text style={{
            color: Colors.baseTextColor
          }} mdxType="Text">
        について
      </Text>
    </Heading>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Paragraph style={{
          color: Colors.secondaryColor
        }} mdxType="Paragraph">
      @natural_clar
    </Paragraph>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Paragraph mdxType="Paragraph">TECH STAND #1 React Native</Paragraph>
  </View>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Hello! 👋</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">
    I'm{" "}
    <Text style={{
          fontWeight: "600"
        }} mdxType="Text">
      Jesse Katsumata
    </Text>
  </Paragraph>
  <MarginBottom size={8} mdxType="MarginBottom" />
  <Row mdxType="Row">
    <View style={{
          width: 32,
          height: 32,
          justifyContent: "center",
          alignItems: "center",
          marginRight: 8
        }} mdxType="View">
      <img src={TwitterLogo} />
    </View>
    <Paragraph mdxType="Paragraph">@natural_clar</Paragraph>
  </Row>
  <MarginBottom size={8} mdxType="MarginBottom" />
  <Row mdxType="Row">
    <View style={{
          width: 32,
          height: 32,
          justifyContent: "center",
          alignItems: "center",
          marginRight: 8
        }} mdxType="View">
      <img src={GithubLogo} />
    </View>
    <Paragraph mdxType="Paragraph">@Naturalclar</Paragraph>
  </Row>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">
    Software Engineer at{" "}
    <Text style={{
          fontWeight: "600"
        }} mdxType="Text">CureApp, Inc.</Text>
  </Paragraph>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">
    Member of{" "}
    <Text style={{
          fontWeight: "600"
        }} mdxType="Text">
      react-native-community
    </Text>
  </Paragraph>
  <MarginBottom size={8} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">maintaining some Lean Core modules</Paragraph>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">❤️ OSS & Music 🎹</Paragraph>
  <View style={{
        position: "absolute",
        height: 240,
        width: 240,
        top: "20%",
        right: "20%",
        transform: [{
          rotate: "-20deg"
        }]
      }} mdxType="View">
    <img src={MyPic} width="50%" />
  </View>
  <View style={{
        position: "absolute",
        height: 240,
        width: 240,
        top: "60%",
        right: "20%"
      }} mdxType="View">
    <img src={CureAppLogo} width="50%" />
  </View>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Row mdxType="Row">
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: 240,
            height: 240
          }} mdxType="View">
        <img src={CureAppLogo} />
      </View>
      <MarginBottom size={60} mdxType="MarginBottom" />
      <View style={{
            flex: 1,
            alignItems: "flex-start"
          }} mdxType="View">
        <Paragraph mdxType="Paragraph">治療アプリの開発</Paragraph>
        <MarginBottom size={8} mdxType="MarginBottom" />
        <Paragraph style={{
              color: Colors.secondaryColor
            }} mdxType="Paragraph">
          国内初の「治療アプリ」の薬事承認 🎉
        </Paragraph>
        <MarginBottom size={8} mdxType="MarginBottom" />
        <Paragraph mdxType="Paragraph">
          全員が{" "}
          <Paragraph style={{
                color: Colors.secondaryColor
              }} mdxType="Paragraph">
            TypeScript{" "}
          </Paragraph>
          エンジニア
        </Paragraph>
        <MarginBottom size={8} mdxType="MarginBottom" />
        <Paragraph mdxType="Paragraph">
          UI、ロジック、サーバー、インフラの分業
        </Paragraph>
        <MarginBottom size={8} mdxType="MarginBottom" />
        <Paragraph mdxType="Paragraph">各管轄でテストを書いている</Paragraph>
      </View>
    </Center>
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: "100%",
            height: "50%"
          }} mdxType="View">
        <img src={CureAppTech} />
      </View>
    </Center>
  </Row>
    </Page>
    <Note mdxType="Note">
  本日、厚生労働省より正式に薬事承認されることとなりました。
    </Note>
    <hr></hr>
    <Page mdxType="Page">
  <Row mdxType="Row">
    <View style={{
          width: "100%",
          height: "100%",
          flex: 1
        }} mdxType="View">
      <SubHeading mdxType="SubHeading">今日話すこと</SubHeading>
      <MarginBottom size={60} mdxType="MarginBottom" />
      <Paragraph mdxType="Paragraph">Visual Regression Test とは</Paragraph>
      <MarginBottom size={16} mdxType="MarginBottom" />
      <Paragraph mdxType="Paragraph">
        Visual Regression Test のためのツール、Reg-suit
        の紹介
      </Paragraph>
      <MarginBottom size={16} mdxType="MarginBottom" />
      <Paragraph mdxType="Paragraph">
        React Native と組み合わせた UI の高速開発方法
      </Paragraph>
      <MarginBottom size={16} mdxType="MarginBottom" />
      <Paragraph mdxType="Paragraph">実演デモ</Paragraph>
    </View>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Row mdxType="Row">
    <View style={{
          width: "100%",
          height: "100%",
          flex: 1
        }} mdxType="View">
      <SubHeading mdxType="SubHeading">Visual Regression Testing</SubHeading>
      <ul>
        <li style={{
              color: Colors.baseTextColor,
              marginBottom: 16
            }}>
          UI Test の一環
        </li>
        <li style={{
              color: Colors.baseTextColor,
              marginBottom: 16
            }}>
          各画面が期待通りの見た目であるかの確認
        </li>
        <ul>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            Email 入力欄がある
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            パスワード入力欄がある
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            ログインボタンがある
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            Loading状態ではLoadingが表示される
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            etc…
          </li>
        </ul>
      </ul>
    </View>
    <Center mdxType="Center">
      <View style={{
            width: 320,
            height: 480,
            borderWidth: 1,
            borderColor: Colors.baseTextColor,
            borderRadius: 5,
            padding: 24,
            alignItems: "center",
            justifyContent: "space-between"
          }} mdxType="View">
        <View style={{
              alignSelf: "stretch"
            }} mdxType="View">
          <Text style={{
                color: Colors.baseTextColor,
                fontSize: 24
              }} mdxType="Text">
            Awesome App Login
          </Text>
          <MarginBottom size={48} mdxType="MarginBottom" />
          <Text style={{
                color: Colors.baseTextColor
              }} mdxType="Text">
            email
          </Text>
          <MarginBottom size={24} mdxType="MarginBottom" />
          <View style={{
                borderBottomColor: Colors.baseTextColor,
                borderBottomWidth: 1
              }} mdxType="View" />
          <MarginBottom size={24} mdxType="MarginBottom" />
          <Text style={{
                color: Colors.baseTextColor
              }} mdxType="Text">
            password
          </Text>
          <MarginBottom size={24} mdxType="MarginBottom" />
          <View style={{
                borderBottomColor: Colors.baseTextColor,
                borderBottomWidth: 1
              }} mdxType="View" />
        </View>
        <View mdxType="View">
          <Row mdxType="Row">
            <View style={{
                  width: 240,
                  height: 60,
                  padding: 24,
                  borderRadius: 24,
                  borderWidth: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  borderColor: Colors.baseTextColor
                }} mdxType="View">
              <Text style={{
                    color: Colors.baseTextColor
                  }} mdxType="Text">
                Login
              </Text>
            </View>
          </Row>
          <MarginBottom size={16} mdxType="MarginBottom" />
          <Row mdxType="Row">
            <View style={{
                  width: 240,
                  height: 60,
                  padding: 24,
                  borderRadius: 24,
                  borderWidth: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  borderColor: Colors.baseTextColor
                }} mdxType="View">
              <Text style={{
                    color: Colors.baseTextColor
                  }} mdxType="Text">
                Login with SNS
              </Text>
            </View>
          </Row>
        </View>
      </View>
    </Center>
  </Row>
    </Page>
    <Note mdxType="Note">
  Visual Regression TestとはUI Test の一環です。UI
  テストと言っても色々あるんですが、Visual Regression Test
  は見た目についてフォーカスします。
    </Note>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Visual Regression Testing</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">
    CI と連携して、Pull Request 毎に元 branch との比較を作成
  </Paragraph>
  <Center mdxType="Center">
    <View style={{
          flex: 1,
          width: "80%"
        }} mdxType="View">
      <img src={Branches} />
    </View>
  </Center>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Row mdxType="Row">
    <View style={{
          width: "100%",
          height: "100%",
          flex: 1
        }} mdxType="View">
      <SubHeading mdxType="SubHeading">Visual Regression Testing</SubHeading>
      <MarginBottom size={60} mdxType="MarginBottom" />
      <Paragraph mdxType="Paragraph">変更発生時に差分を検知する</Paragraph>
    </View>
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: "65%"
          }} mdxType="View">
        <img src={VisRegDiff} />
      </View>
    </Center>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Visual Regression Testing</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">DOMの実装方法に無関心</Paragraph>
  <Row mdxType="Row">
    <Center style={{
          flex: 2
        }} mdxType="Center">
      <View style={{
            flex: 1,
            width: "60%"
          }} mdxType="View">
        <img src={VisRegSide} />
      </View>
    </Center>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Visual Regression Testing</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">Pull Request 毎にレポートを作成</Paragraph>
  <MarginBottom size={8} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">不本意な変更を防ぐことが可能</Paragraph>
  <Center mdxType="Center">
    <View style={{
          flex: 1,
          width: "80%"
        }} mdxType="View">
      <img src={VisRegReport} />
    </View>
  </Center>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <img src={RegSuitLogo} />
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">REG SUIT</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        CLI で
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        セットアップ可能
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Screenshot を
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        クラウドに
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        保管 (S3, GCS)
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        無料で使える
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Row mdxType="Row">
    <Center mdxType="Center">
      <View style={{
            width: "50%"
          }} mdxType="View">
        <img src={StorybookLogo} />
      </View>
    </Center>
    <Center mdxType="Center">
      <SubHeading mdxType="SubHeading">with React Native for Web</SubHeading>
    </Center>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Storybook + React Native Web</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        ロジックを省いた
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        見た目の確認
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        エミュレーター
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        要らず
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        効率的
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">分業</Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <CodeSurferColumns themes={[github, vsDark]} mdxType="CodeSurferColumns">
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "subtitle=\"SignUp Page\"",
            "subtitle": "\"SignUp",
            "Page\"": true
          }}>{`// SignUpPage.tsx
import React from "react";
import { Page, SignUpForm, PrimaryButton } from "../src";

export const SignUpPage = () => {
  return (
    <Page>
      <SignUpForm />
      <PrimaryButton label={"SignUp"} onPress={SignUp} />
    </Page>
  );
};
`}</code></pre>
        <View style={{
          width: 320,
          height: 480,
          borderWidth: 1,
          borderColor: "white",
          borderRadius: 5,
          padding: 24,
          alignItems: "center",
          justifyContent: "space-between"
        }} mdxType="View">
  <View style={{
            alignSelf: "stretch"
          }} mdxType="View">
    <Text style={{
              color: "white",
              fontSize: 24
            }} mdxType="Text">
      Awesome App Signup
    </Text>
    <MarginBottom size={48} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">email</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">password</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
  </View>
  <View style={{
            width: 150,
            height: 60,
            padding: 24,
            borderRadius: 24,
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "white"
          }} mdxType="View">
    <Text style={{
              color: "white"
            }} mdxType="Text">SignUp</Text>
  </View>
        </View>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "subtitle=\"PrimaryButton\"",
            "subtitle": "\"PrimaryButton\""
          }}>{`// PrimaryButton.tsx
import React from "react";
import { View, Text } from "react-native";

export const PrimaryButton = ({ label, onPress }) => {
  return (
    <TouchableOpacity
      style={{
        width: 150,
        height: 60,
        padding: 24,
        borderRadius: 24,
        borderWidth: 1,
        alignItems: "center",
        justifyContent: "center",
        borderColor: "white",
      }}
    >
      <Text>{label}</Text>
    </TouchableOpacity>
  );
};
`}</code></pre>
        <View style={{
          width: 320,
          height: 480,
          borderWidth: 1,
          borderColor: "white",
          borderRadius: 5,
          padding: 24,
          alignItems: "center",
          justifyContent: "space-between"
        }} mdxType="View">
  <View style={{
            alignSelf: "stretch"
          }} mdxType="View">
    <Text style={{
              color: "white",
              fontSize: 24
            }} mdxType="Text">
      Awesome App Signup
    </Text>
    <MarginBottom size={48} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">email</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">password</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
  </View>
  <View style={{
            width: 150,
            height: 60,
            padding: 24,
            borderRadius: 24,
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "white"
          }} mdxType="View">
    <Text style={{
              color: "white"
            }} mdxType="Text">SignUp</Text>
  </View>
        </View>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "subtitle=\"PrimaryButton\"",
            "subtitle": "\"PrimaryButton\""
          }}>{`// PrimaryButton.tsx
import React from "react";
import { View, Text } from "react-native";

export const PrimaryButton = ({ label, onPress }) => {
  return (
    <TouchableOpacity
      style={{
        width: 240,
        height: 60,
        padding: 24,
        borderRadius: 24,
        borderWidth: 1,
        alignItems: "center",
        justifyContent: "center",
        borderColor: "white",
      }}
    >
      <Text>{label}</Text>
    </TouchableOpacity>
  );
};
`}</code></pre>
        <View style={{
          width: 320,
          height: 480,
          borderWidth: 1,
          borderColor: "white",
          borderRadius: 5,
          padding: 24,
          alignItems: "center",
          justifyContent: "space-between"
        }} mdxType="View">
  <View style={{
            alignSelf: "stretch"
          }} mdxType="View">
    <Text style={{
              color: "white",
              fontSize: 24
            }} mdxType="Text">
      Awesome App Signup
    </Text>
    <MarginBottom size={48} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">email</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">password</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
  </View>
  <View style={{
            width: 240,
            height: 60,
            padding: 24,
            borderRadius: 24,
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "white"
          }} mdxType="View">
    <Text style={{
              color: "white"
            }} mdxType="Text">SignUp</Text>
  </View>
        </View>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "subtitle=\"Login Page\"",
            "subtitle": "\"Login",
            "Page\"": true
          }}>{`// PrimaryButton.tsx
import React from "react";
import { View, Text } from "react-native";
import {
  Page,
  LoginForm,
  Row,
  PrimaryButton,
} from "../src";

export const LoginPage = () => {
  return (
    <Page>
      <LoginForm />
      <Row>
        <PrimaryButton
          label={"Register"}
          onPress={Register}
        />
        <PrimaryButton label={"Login"} onPress={Login} />
      </Row>
    </Page>
  );
};
`}</code></pre>
        <View style={{
          width: 320,
          height: 480,
          borderWidth: 1,
          borderColor: "white",
          borderRadius: 5,
          padding: 24,
          alignItems: "center",
          justifyContent: "space-between"
        }} mdxType="View">
  <View style={{
            alignSelf: "stretch"
          }} mdxType="View">
    <Text style={{
              color: "white",
              fontSize: 24
            }} mdxType="Text">
      Awesome App Login
    </Text>
    <MarginBottom size={48} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">email</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">password</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
  </View>
  <Row mdxType="Row">
    <View style={{
              width: 240,
              height: 60,
              padding: 24,
              borderRadius: 24,
              borderWidth: 1,
              alignItems: "center",
              justifyContent: "center",
              borderColor: "white"
            }} mdxType="View">
      <Text style={{
                color: "white"
              }} mdxType="Text">Register</Text>
    </View>
    <View style={{
              width: 240,
              height: 60,
              padding: 24,
              borderRadius: 24,
              borderWidth: 1,
              alignItems: "center",
              justifyContent: "center",
              borderColor: "white"
            }} mdxType="View">
      <Text style={{
                color: "white"
              }} mdxType="Text">Login</Text>
    </View>
  </Row>
        </View>
      </Step>
    </CodeSurferColumns>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">まとめ - Visual Regression Test</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle size={360} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        レビュー時間短縮
      </Paragraph>
    </Circle>
    <Circle size={360} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        ライブラリの
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        アップデートが安心
      </Paragraph>
    </Circle>
    <Circle size={360} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Storybook による
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        UI開発の高速化
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Center mdxType="Center">
    <Heading mdxType="Heading">DEMO</Heading>
  </Center>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Center mdxType="Center">
    <Heading mdxType="Heading">THANK YOU!</Heading>
  </Center>
    </Page>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;